import { useOrg } from './OrgProvider';

/** Selector de organización activa. Cambia el contexto de datos de toda la app. */
export function OrgSwitcher() {
  const { organizations, activeOrg, setActiveOrg } = useOrg();

  if (organizations.length === 0) return null;

  if (organizations.length === 1) {
    return (
      <span className="text-sm font-medium" data-testid="org-single">
        {activeOrg?.name}
      </span>
    );
  }

  return (
    <label className="flex items-center gap-2 text-sm">
      <span className="sr-only">Organización activa</span>
      <select
        value={activeOrg?.organization_id ?? ''}
        onChange={(e) => setActiveOrg(e.target.value)}
        className="min-h-11 rounded-[var(--radius-control)] border border-[var(--linea-fuerte)] px-2"
        data-testid="org-switcher"
      >
        {organizations.map((o) => (
          <option key={o.organization_id} value={o.organization_id}>
            {o.name}
          </option>
        ))}
      </select>
    </label>
  );
}
